import React from 'react';

const OCLEmptyGraphic = () => {
  return (
    <svg width="236" height="139" viewBox="0 0 236 139" fill="none">
      <g clipPath="url(#71mxjbogca)" stroke="#5E5C71" strokeMiterlimit="10" strokeDasharray="3 3">
        <path d="M46.41 138.721c25.477 0 46.13-20.661 46.13-46.147 0-25.487-20.653-46.148-46.13-46.148C20.932 46.426.279 67.087.279 92.574c0 25.486 20.653 46.147 46.13 46.147zM128.815 91.52C108.071 87.003 92.54 68.533 92.54 46.426c0-23.244 17.182-42.478 39.531-45.679M228.963 39.673c9.008-9.012 9.008-23.623 0-32.635-9.009-9.012-23.615-9.012-32.624 0-9.008 9.012-9.008 23.623 0 32.635 9.009 9.012 23.615 9.012 32.624 0zM175.319 65.712c7.841-10.046 6.056-24.547-3.987-32.39-10.042-7.843-24.538-6.057-32.378 3.988-7.84 10.046-6.055 24.548 3.987 32.39 10.042 7.844 24.538 6.058 32.378-3.988zM211.351 105.294c4.21-12.026-2.123-25.189-14.144-29.4-12.021-4.212-25.179 2.123-29.389 14.149-4.21 12.026 2.123 25.188 14.144 29.4 12.021 4.211 25.179-2.124 29.389-14.149z"/>
      </g>
      <defs>
        <clipPath id="71mxjbogca">
          <path fill="#fff" d="M0 0h236v139H0z"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default OCLEmptyGraphic;
